import { useEffect, useState } from 'react';
import { ApiPassengers } from 'common/api';
import { handleAuthError } from 'common/handlers';
import { Button, Flex } from 'components';
import { ModalLoader, ModalAddPassenger, PageSidebar } from 'shared/components';
import { ModalDeletePassengerConfirm, PassengerCard } from './components';
import { IClientPassengerBrief } from '@bustickus/models-client';

function PagePassengers() {
  const [passengers, setPassengers] = useState<IClientPassengerBrief[] | null>(null);
  const [addPassengerModal, setAddPassengerModal] = useState<boolean>(false);
  const [editPassengerModal, setEditPassengerModal] = useState<string | null>(null);
  const [deletePassengerModal, setDeletePassengerModal] = useState<IClientPassengerBrief | null>(null);

  useEffect(() => {
    loadPassengers();
  }, []);

  const loadPassengers = async () =>
    await handleAuthError(async () => {
      const apiPassengers = ApiPassengers.getInstance();
      setPassengers(await apiPassengers.getAll());
    });

  const refreshPassengers = async () => {
    setPassengers(null);
    await loadPassengers();
  };

  return (
    <PageSidebar
      title='Пассажиры'
      frameTitle='Пассажиры'
    >
      {passengers == null && <ModalLoader />}
      {addPassengerModal && (
        <ModalAddPassenger
          onClose={() => setAddPassengerModal(false)}
          onSaved={refreshPassengers}
        />
      )}

      {editPassengerModal && (
        <ModalAddPassenger
          onClose={() => setEditPassengerModal(null)}
          onSaved={refreshPassengers}
          passengerId={editPassengerModal}
        />
      )}

      {deletePassengerModal && (
        <ModalDeletePassengerConfirm
          passenger={deletePassengerModal}
          onDeleted={refreshPassengers}
          onClose={() => setDeletePassengerModal(null)}
        />
      )}
      <Flex
        direction='column'
        gap={10}
      >
        {passengers?.map((p) => (
          <PassengerCard
            key={p.id}
            passenger={p}
            onDeleteClick={() => setDeletePassengerModal(p)}
            onEditClick={() => setEditPassengerModal(p.id)}
          />
        ))}

        <Button
          color='red'
          onClick={() => setAddPassengerModal(true)}
        >
          Добавить пассажира
        </Button>
      </Flex>
    </PageSidebar>
  );
}

export default PagePassengers;
